import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import SplineApi from "../../tools/spline-api.js";

export interface IssueCusipRow {
  cusip: string;
  maturity_date: string;
  total_maturity_offering_amt: number;
  offering_yield: number;
}

export default function useIssueCusips() {
  const { getAccessTokenSilently } = useAuth0();
  const [issueCusips, setIssueCusips] = useState<IssueCusipRow[]>([]);

  const fetchIssueCusips = async (cusip: string) => {
    setIssueCusips([]);

    try {
      const token = await getAccessTokenSilently();
      const api = new SplineApi(token);
      const response = await api.getIssueCusips(cusip);
      setIssueCusips(response as IssueCusipRow[]);
    } catch (_e) {
      // Best-effort: if this fails, the table simply falls back to only the cusips with trade data.
      setIssueCusips([]);
    }
  };

  return { fetchIssueCusips, issueCusips };
}
